module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              BRANDED ARTICLE DETAILS\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n              Location\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrand.location),
      expression: "newBrand.location"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newBrand, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Please Select Location")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.text,
      domProps: {
        "value": state.text
      }
    }, [_vm._v("\n                    " + _vm._s(state.text) + "\n                  ")])
  })], 2)]), _vm._v("\n              Branded article slug\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrand.url),
      expression: "newBrand.url"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newBrand.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBrand, "url", $event.target.value)
      }
    }
  })]), _vm._v("\n              Pageviews needed\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrand.pageviews),
      expression: "newBrand.pageviews"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.newBrand.pageviews)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBrand, "pageviews", $event.target.value)
      }
    }
  })]), _vm._v("\n              Current pageviews\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrand.currentPageviews),
      expression: "newBrand.currentPageviews"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.newBrand.currentPageviews)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBrand, "currentPageviews", $event.target.value)
      }
    }
  })]), _vm._v("\n              Pageviews needed by which date?\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrand.endDate),
      expression: "newBrand.endDate"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.newBrand.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBrand, "endDate", $event.target.value)
      }
    }
  })]), _vm._v("\n              Probability\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrand.probability),
      expression: "newBrand.probability"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.newBrand.probability)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBrand, "probability", $event.target.value)
      }
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.addNewBrand
    }
  }, [_vm._v("\n                ADD ARTICLE\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cdd226e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/branded/ModalBranded.vue
// module id = 651
// module chunks = 1